<!-- 经销商信息 -->
<template>
    <div
        v-if="componentsData.type == 20"
        class="bg-div"
        :style="
            componentsData.content.version
                ? {
                      ...(componentsData.content.bg_color && {
                          backgroundColor: componentsData.content.bg_color,
                      }),
                      ...(componentsData.content.bg_img.picview &&
                          componentsData.content.bg_value && {
                              backgroundImage: `url(${componentsData.content.bg_img.picview})`,
                          }),
                      padding: `${componentsData.content.paddingData.top}px ${componentsData.content.paddingData.left}px`,
                      margin: `${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px`,
                      borderRadius: `${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.bottom}px ${componentsData.content.radiusData.bottom}px`,
                  }
                : `padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px;background: ${componentsData.content.bg_color};border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px`
        "
    >
        <div>
            <div
                v-if="componentsData.content.style_value == 1"
                class="fw-bold flex-c"
                :style="`border-bottom: 1px solid ${componentsData.content.title_border_color};font-size: ${componentsData.content.title_size}px;color: ${componentsData.content.title_color};background: ${componentsData.content.title_bc};`"
            >
                <div class="dec-left" :style="{ background: decLeft }"></div>
                <div class="dec-content">经销商名称</div>
                <div class="dec-right" :style="{ background: decRight }"></div>
            </div>
            <div
                v-else
                class="fw-bold"
                :style="`border-bottom: 1px solid ${componentsData.content.title_border_color};text-align: ${componentsData.content.position};font-size: ${componentsData.content.title_size}px;color: ${componentsData.content.title_color};background: ${componentsData.content.title_bc};`"
            >
                经销商名称
            </div>
            <div
                class="mt-6"
                :style="`font-size: ${componentsData.content.size}px;`"
            >
                <div
                    v-if="componentsData.content.type.includes('授权编号')"
                    class="mt-6"
                >
                    <span
                        :style="`color: ${componentsData.content.text_color};`"
                        >授权编号：</span
                    >
                    <span :style="`color: ${componentsData.content.txt_color};`"
                        >123456</span
                    >
                </div>
                <div
                    v-if="componentsData.content.type.includes('手机号码')"
                    class="mt-6"
                >
                    <span
                        :style="`color: ${componentsData.content.text_color};`"
                        >手机号码：</span
                    >
                    <span :style="`color: ${componentsData.content.txt_color};`"
                        >12345678912</span
                    >
                </div>
                <div
                    v-if="componentsData.content.type.includes('负责区域')"
                    class="mt-6 dis-flex"
                >
                    <div
                        :style="`color: ${componentsData.content.text_color};`"
                    >
                        负责区域：
                    </div>
                    <div
                        class="w230"
                        :style="`color: ${componentsData.content.txt_color};`"
                    >
                        宁夏银川贺兰县、天津天津河东区、安徽安庆望江县、安徽安庆太湖县
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {};
    },
    computed: {
        decLeft() {
            return `linear-gradient(to left, ${this.componentsData.content.dec_color}, transparent)`;
        },
        decRight() {
            return `linear-gradient(to right, ${this.componentsData.content.dec_color}, transparent)`;
        },
    },
    mounted() {},
    methods: {},
};
</script>

<style scoped>
.fw-bold {
    padding-bottom: 6px;
    font-weight: bold;
}
.mt-6 {
    margin: 6px 0 0 0;
}
.dis-flex {
    display: flex;
}
.w230 {
    width: 230px;
}
.dec-left {
    margin: 0 12px;
    width: 50px;
    height: 4px;
    border-radius: 2px;
}
.dec-right {
    margin: 0 12px;
    width: 50px;
    height: 4px;
    border-radius: 2px;
}
.dec-content {
    max-width: 200px;
    white-space: nowrap; /* 确保文本不会换行 */
    overflow: hidden; /* 隐藏溢出的文本 */
    text-overflow: ellipsis; /* 显示省略号来代表被修剪的文本 */
}
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
</style>